module.exports = __webpack_public_path__ + "img/yxkh.86e8cf17.png";